import React from 'react';

const SidePen = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12.572 10.78 1-1A.251.251 0 0 1 14 9.96v4.543a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5v-11a1.5 1.5 0 0 1 1.5-1.5h8.547c.222 0 .334.27.178.428l-1 1a.248.248 0 0 1-.178.072H1.5v11h11v-3.546c0-.066.025-.129.072-.175Zm4.894-6.306L9.259 12.68l-2.825.313c-.818.09-1.515-.6-1.425-1.425l.313-2.825L13.528.537a1.824 1.824 0 0 1 2.585 0l1.35 1.35a1.83 1.83 0 0 1 .003 2.587Zm-3.088.966-1.816-1.816-5.806 5.81-.228 2.04 2.04-.228 5.81-5.806Zm2.025-2.49-1.35-1.35a.326.326 0 0 0-.462 0l-.966.965 1.816 1.815.965-.965a.333.333 0 0 0-.003-.466Z"
    />
  </svg>
);

export default SidePen;
